'use strict';

import type { AgencyConnecture } from '../../Entities/Agency/AgencyConnecture';
import { EntityCollection } from '../EntityCollection';

export class AgencyConnectureCollection extends EntityCollection<AgencyConnecture> {}
